import { useState } from 'react';

export type DialogType = 'reprocess' | 'delete' | 'tagManagement';
export type DialogsState = Record<DialogType, boolean>;

export interface RecordDialogsReturn extends DialogsState {
  openDialog: (dialog: DialogType) => void;
  closeDialog: (dialog: DialogType) => void;
}

export const useRecordDialogs = (): RecordDialogsReturn => {
  const [dialogsState, setDialogsState] = useState<DialogsState>({
    reprocess: false,
    delete: false,
    tagManagement: false,
  });

  const openDialog = (dialog: DialogType) => {
    setDialogsState(prev => ({ ...prev, [dialog]: true }));
  };

  const closeDialog = (dialog: DialogType) => {
    setDialogsState(prev => ({ ...prev, [dialog]: false }));
  };

  return {
    ...dialogsState,
    openDialog,
    closeDialog,
  };
};